/**
 * Ordering rule for the sponsor directory listing.
 *
 * `SponsorsList` renders from this, and the directory's ItemList JSON-LD is
 * built from it too, so the nth structured-data entry is by construction the
 * nth link a visitor sees rather than by coincidence.
 */

export interface DirectorySponsor {
  id: number;
  name: string;
}

export function orderSponsorsForDirectory(
  sponsors: Pick<DirectorySponsor, 'id' | 'name'>[],
): DirectorySponsor[] {
  return (
    sponsors
      .filter(sponsor => sponsor?.name && sponsor.name.trim())
      .map(sponsor => ({ id: sponsor.id, name: sponsor.name.trim() }))
      // Locale pinned to 'en' rather than left to the runtime default. This runs
      // twice — on the server to build the ItemList, again in the browser during
      // hydration — and collations disagree: under 'sv', "Ärzte" sorts after "Z".
      // An unpinned locale means a hydration mismatch on a ~740-row list and an
      // ItemList whose positions stop matching the links a visitor sees.
      .sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }))
  );
}
